// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"245":"331da55eb533ed45","580":"cb72db75afd563f0","786":"2275502f1e900e5a"}[chunkId] + ".js";
};